import React, { useEffect, useState } from "react";
import axios from "axios";
import { SERVER_URL } from "../config";

interface InvoiceItem {
  id?: string;
  description: string;
  quantity: number;
  unitPrice: string;
}

interface Invoice {
  id: string;
  userId: string;
  status: string;
  totalAmount: string;
  items: InvoiceItem[];
}

interface PatientInvoiceProps {
  patientId: string;
}

const PatientInvoice: React.FC<PatientInvoiceProps> = ({ patientId }) => {
  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    const fetchInvoices = async () => {
      setLoading(true);
      try {
        // Fetch all invoices from the backend.
        const response = await axios.get<Invoice[]>(
          `${SERVER_URL}/api/invoice/invoices`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        // Filter invoices where the userId matches the given patientId.
        const patientInvoices = response.data.filter(
          (invoice) => invoice.userId === patientId
        );
        setInvoices(patientInvoices);
      } catch (err: any) {
        setError(err.response?.data?.error || "Error fetching invoices");
      }
      setLoading(false);
    };

    fetchInvoices();
  }, [patientId]);

  if (loading) {
    return <div>Loading invoices...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (invoices.length === 0) {
    return <div>No invoices found for this patient.</div>;
  }

  return (
    <div>
      <h2>Patient Invoices</h2>
      {invoices.map((invoice) => (
        <div
          key={invoice.id}
          style={{
            border: "1px solid #ccc",
            borderRadius: "5px",
            padding: "10px",
            marginBottom: "15px",
          }}
        >
          <p>
            <strong>Invoice ID:</strong> {invoice.id}
          </p>
          <p>
            <strong>Status:</strong> {invoice.status}
          </p>
          <p>
            <strong>Total Amount:</strong> {invoice.totalAmount}
          </p>
          {invoice.items && invoice.items.length > 0 && (
            <div>
              <strong>Items:</strong>
              <ul>
                {invoice.items.map((item, index) => (
                  <li key={index}>
                    {item.description} – Quantity: {item.quantity}, Unit Price:{" "}
                    {item.unitPrice}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default PatientInvoice;
